const testimonials = [
  {
    initials: 'MR',
    name: 'Marina Rocha',
    role: 'Proprietária, Botequim da Marina · SP',
    quote: '"Em 2 semanas já tínhamos o site no ar, o cardápio digital funcionando e os pedidos das mesas chegando direto na cozinha. Minha equipe adorou."',
  },
  {
    initials: 'CS',
    name: 'Carlos Souza',
    role: 'Sócio, Pizzaria do Bairro · RJ',
    quote: '"Paramos de pagar comissão para o iFood nos pedidos de retirada. Só nisso já pagamos a mensalidade várias vezes. Faz sentido demais."',
  },
  {
    initials: 'AK',
    name: 'Aiko Nakamura',
    role: 'Chef-proprietário, Sushi Nakamura · BH',
    quote: '"O QR code nas mesas mudou tudo. Os clientes pedem na hora que querem, a cozinha recebe na hora, e o garçom pode focar no atendimento."',
  },
]

export default function Testimonials() {
  return (
    <section className="bg-black text-white px-5 py-16 sm:px-8 sm:py-20 lg:px-16 lg:py-24">
      <div className="max-w-[1140px] mx-auto">
        <div className="text-[11px] font-bold uppercase tracking-[2px] text-white/40 mb-3">
          O que falam de nós
        </div>
        <h2 className="text-[30px] sm:text-[38px] lg:text-[50px] font-black tracking-tight leading-[1.1] text-white">
          Restaurantes que<br />já cresceram com WaitHere.
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-10 lg:mt-16">
          {testimonials.map((t) => (
            <div key={t.name} className="bg-white/5 border border-white/8 rounded-2xl p-6">
              <div className="text-[15px] tracking-[2px] mb-3.5">★★★★★</div>
              <p className="text-[15px] leading-[1.7] text-white/80 mb-5">{t.quote}</p>
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-white/15 rounded-full flex items-center justify-center text-[13px] font-bold text-white flex-shrink-0">
                  {t.initials}
                </div>
                <div>
                  <div className="text-sm font-bold text-white">{t.name}</div>
                  <div className="text-xs text-white/45">{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
